// @ts-nocheck

function fetch(...args) {
  console.log(args, JSON.stringify(args));
  return global.fetch(...args);
}

export default fetch;
